import catalogConfig from '../config/catalogConfig.mjs';
import { getContext, getContextParams } from './eventContext.mjs';
import { getPlatform } from './platform.mjs';
export default (trigger, config) => {
    return {
        name: config.event.name,
        params: {
            ...(config.event.params || {}),
            ...trigger.params,
            context: getContext(),
            ...getContextParams(),
            feature: trigger.name.split('.').slice(0, -1).join('_'),
            is_non_interactive: Boolean(trigger.isNonInteractive),
            cb_platform: getPlatform(),
            version: catalogConfig.version,
        },
        isNonInteractive: Boolean(trigger.isNonInteractive),
        isPrivacyFriendly: catalogConfig.privacyFriendlyEvents.includes(config.event.name),
        excludeFromGA: catalogConfig.excludeEventsFromGA.includes(config.event.name),
    };
};
